"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // import { Cls1, Cls2, Cls3 } from './styles';


var Logo = function Logo(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className;
  return _react["default"].createElement("div", {
    className: className
  }, _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 345.37 281.43",
    width: width,
    height: height
  }, _react["default"].createElement("defs", null, _react["default"].createElement("style", null, ".cls-1 {\n            fill: none;\n            stroke: #fafafa;\n            stroke-linecap: round;\n            stroke-miterlimit: 10;\n            stroke-width: 2.52px;\n          }\n          .cls-2{ fill: #fafafa; }\n          ")), _react["default"].createElement("path", {
    className: "cls-1",
    d: "M125.17,78.72c4.89-14.46,8.44-13.74,12.43-22.13,3-6.27,5-14-.41-19.41-2.43-2.45-6.56-3.91-9.67-1.83s-3.46, 6.51-1.87,9.6c1.85,3.6,6.06,5.31,9.89,5.69,3.54.35,7.26.94,10.78.24,9.34-1.86,18.54-5.46,28.19-3.77,14.56, 2.54,27.21,11.12,42.42,10.6a47.76,47.76,0,0,0,21.3-5.91c2.85-1.55,5.73-4.69, 4.1-8.19-.93-2-3.22-3.09-5-4.18q-3.47-2.14-7-4.16a180.13,180.13,0,0, 0-40.82-17.34c-4.24-1.18-10.63-2.88-14.4.37-2.85,2.46-3.43,5.93-1.29,9,2,2.8,5.27,4.21,8.35,5.42,14.23,5.57, 30.3,6.71,45.38,8.11l10.81,1c3.12.29,6.39.92,9.53.65,4.39-.38,2.7-3.81,1.15-6.49a110.54,110.54,0,0, 0-7.57-11.53C236,17.21,229.5,10.46,221.7,5.81,216.15,2.5,205.84-2,201.06,4.89s5.32,11.85,10.3,13.86c8.74, 3.53,17.67,6.35,26.21,10.39a153,153,0,0,1,24.79,14.57A121,121,0,0,1,273.2,52.6c3.28,3,7.19,6.44,8.35,10.95, 1,3.85-.41,8.19-4.42,9.55s-8.19-.37-12.21-.66c-3.33-.24-8.47.44-9.17,4.54-.87,5.15,8.1,4,10.93,3.6,5-.72, 9.85-2.28,14.91-2a19.91,19.91,0,0,1,12.08,5.06c5.81,5.37,6.59,15.51-2.29,18-8.15, 2.31-14.57-4-22-6-9.06-2.4-15.76,2.56-23.1,7a18.18,18.18,0,0,1-11.54,2.6c-4.87-.63-6.95-3.71-10.2-6.91A38.89, 38.89,0,0,0,204,88.33a48.22,48.22,0,0,0-21.48,1.21c-6.32,1.83-11.5,5.13-16.52,9.3-5.48,4.55-12.25,9.83-19.45, 10.88-4.37.64-8.7-.52-12.87-1.75-5-1.46-9.88-3.06-14.87-4.39-9.77-2.61-18.92-2.47-28,2.16C82.38,110,75.31, 116.3,67.41,121.28a49.66,49.66,0,0,1-13.26,6.24c-3.43.93-10,2.26-13-.34-3.34-2.91-.28-6.75,2.25-8.78, 3.13-2.5,6.93-4,10.64-5.37a98.81,98.81,0,0,0,24.33-12.88A104.54,104.54,0,0,0,89,91.05c3.1-3,6.22-6.12, 10-8.3a20,20,0,0,1,11.51-2.65c3.55.31,6.72,2.26,9.89,3.72"
  }), _react["default"].createElement("path", {
    className: "cls-2",
    d: "M0,168.41H17.23v56.07H55.39v12.65H0Z"
  }), _react["default"].createElement("path", {
    className: "cls-2",
    d: "M64.93,168.41H82.15v68.72H64.93Z"
  }), _react["default"].createElement("path", {
    className: "cls-2",
    d: "M101.33,168.41h44.58c7.11.19,15.77.39,20.44,7.11a16.71,16.71,0,0,1,2.73,9.73,14,14,0,0,1-11.39,14.6c4.28, 1.17,14.89,3.8,14.89,17.52A21.16,21.16,0,0,1,169.47,229c-5.35,8.08-14.21,8.08-20.93,8.18H101.33Zm17, 27.06H143a16.37,16.37,0,0,0,5.55-.68c4.09-1.65,4.09-6.23,4.09-7,0-7.3-5.55-7.4-8.27-7.4h-26Zm0, 29.59h25.8c3.89,0,11.19.1,11.19-9.34,0-8.27-6.52-8.27-9.05-8.27H118.36Z"
  }), _react["default"].createElement("path", {
    className: "cls-2",
    d: "M188.54,168.41h64.05v12.36H205.77v15.48H251v12.17H205.77v16.45h48.77v12.26h-66Z"
  }), _react["default"].createElement("path", {
    className: "cls-2",
    d: "M269.82,168.41h47.31c7.79,0,14.89.68,20.64,7.3A20.34,20.34,0,0,1,342.24,189c0,5.26-1.75,11.49-6.62, 15.19-3.7,2.82-8.47,3.8-11.19,4.28l20.83,28.72H325l-18.4-27.64H287.05v27.64H269.82Zm17.23,28.91H314.5c3.7,0, 10.32-.49,10.32-8.18a9.74,9.74,0,0,0-1.36-5.35c-1.27-1.65-2.92-3.31-9.73-3.31H287.05Z"
  }), _react["default"].createElement("path", {
    className: "cls-2",
    d: "M190.56,273.1a17.75,17.75,0,0,1-1.88,2.73c-3.57,4.25-8.34,5.61-12.91,5.61-11.3,0-15.91-8.22-15.91-15, 0-8.58,7-14.91,15.91-14.91a17.57,17.57,0,0,1,8.34,2,14.81,14.81,0,0,1,5.73,5.73l-2.37,1.32a15.29,15.29,0,0, 0-1.6-2.32,12.61,12.61,0,0,0-9.94-4.25c-7.62,0-13.07,5.25-13.07,12.59,0,6.57,4.85,12.31,13.07,12.31a13.29, 13.29,0,0,0,12.19-7Z"
  }), _react["default"].createElement("path", {
    className: "cls-2",
    d: "M207.21,252.41l14.27,28.3h-2.93l-3.65-7.34H196.66l-3.61,7.34h-2.81l13.91-28.3Zm-1.52,2.53-7.94,16.19h16Z"
  }), _react["default"].createElement("path", {
    className: "cls-2",
    d: "M225,252.41h18.6c2.61,0,5.61.08,7.86,2.4a7.65,7.65,0,0,1,2,5.33,7.34,7.34,0,0,1-3.65,6.57c-2.2,1.28-4.81, 1.32-6.73,1.32H227.81v12.67H225Zm2.77,13.31H242.2c2,0,4.21,0,5.93-1a5,5,0,0,0,2.49-4.53,6.93,6.93,0,0, 0-.4-2.32c-1-2.32-3-3.09-6.29-3.09H227.81Z"
  }), _react["default"].createElement("path", {
    className: "cls-2",
    d: "M258.39,252.41h2.69v28.3h-2.69Z"
  }), _react["default"].createElement("path", {
    className: "cls-2",
    d: "M264.24,252.41h27.54v2.36H279.63v25.93h-2.69V254.78H264.24Z"
  }), _react["default"].createElement("path", {
    className: "cls-2",
    d: "M304.13,252.41l14.27,28.3h-2.93l-3.65-7.34H293.59L290,280.71h-2.81l13.91-28.3Zm-1.52,2.53-7.94,16.19h16Z"
  }), _react["default"].createElement("path", {
    className: "cls-2",
    d: "M324.77,252.41v25.93h20.6v2.37H322v-28.3Z"
  })));
};

Logo.propTypes = {
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Logo.defaultProps = {
  width: '100%',
  height: '100%',
  className: ''
};
var _default = Logo;
exports["default"] = _default;